import type { HomeDto } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { useSelector } from 'react-redux'

dayjs.extend(isoWeek)

type UseEnableRotaTrialReturn = {
  enableRotaTrial: () => Promise<any>
}

const useEnableRotaTrial = (): UseEnableRotaTrialReturn => {
  const homeId = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  ).id

  const enableRotaTrial = async (): Promise<any> => {
    return postJSON({
      url: `list/homes/${homeId}/rota/enable-rota-trial`,
      method: 'POST'
    })
  }

  const handleEnableRotaTrial = async () => {
    try {
      const result = await enableRotaTrial()
      window.location.reload()
      return result
    } catch (err) {
      return err
    }
  }

  return {
    enableRotaTrial: handleEnableRotaTrial
  }
}

export default useEnableRotaTrial
